var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L0 4",
    stroke: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4V2C5 1.44772 5.44772 1 6 1H10C10.5523 1 11 1.44772 11 2V4",
    stroke: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14L5 7",
    stroke: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L8 7",
    stroke: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14L11 7",
    stroke: "currentcolor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4V15C2 16.1046 2.89543 17 4 17H12C13.1046 17 14 16.1046 14 15V4",
    stroke: "currentcolor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cfb68af1dac847c0eae6b1a51ac675a1.svg";
export { ForwardRef as ReactComponent };